module.exports = __webpack_public_path__ + "img/26.56bec098.png";